import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import Module from '@tools/ui/components/common/layout/Module';
import { ViewName } from '@tools/ui/enums';
import type { ModuleComponent } from '@tools/ui/types';
import { unmatchTasksNewQueryArgs } from '@tools/ui-utils/busy/predefinedFilters.unmatch-tasks';
import { PageTitle } from '../components/PageTitle';
import PageView from '../components/PageView';
import { useUpdateTab } from '../hooks/useUpdateTab';
import { UNMATCH_TASKS_MAIN_TABS } from './i18.unmatch-tasks';

const verificationTasksArgs = {
  [UNMATCH_TASKS_MAIN_TABS.PENDING]: unmatchTasksNewQueryArgs
};

export const UnmatchTasks: ModuleComponent = ({ router }) => {
  const { t } = useTranslation();

  const { getTabAmount } = useUpdateTab(
    ViewName.busyUnmatchTasksTable,
    verificationTasksArgs
  );

  return (
    <PageView>
      <PageTitle level={3}>
        {t('busy.unmatchTasks.inbox.title') as ReactNode}
      </PageTitle>
      <Module router={router} getTabAmount={getTabAmount} />
    </PageView>
  );
};
